import React from 'react';
import { connect } from 'react-redux'
import MyCustomersCount from './quick-stats/MyCustomersCount';
import AllCustomersCount from './quick-stats/AllCustomersCount';
import TotalAgentsOnline from './quick-stats/TotalAgentsOnline';
import TotalAgentsActive from './quick-stats/TotalAgentsActive';

class CurrentlyBeingServed extends React.Component {

    render(){
        const { tickets, authenticatedUser, sessions } = this.props

        // find tickets that are not served yet
        const priorityTickets = tickets.filter( data => 
            (   
                // get tickets that are not called yet AND
                ( Number(data.status) === 0 
                    && (
                        //  are included in my services
                        //  first make sure it is not allocated to something else
                        (
                            data.manage != null
                            ?   data.manage.userId == null && data.manage.supportDeskId == null
                                ?   ( authenticatedUser.services.includes(data.serviceId) )
                                : 1 === 2 // used to exit check
                            : ( authenticatedUser.services.includes(data.serviceId) )
                        )

                        // or were sent to my userId
                        || ( 
                            data.manage != null 
                            ?   data.manage.userId!= null
                                ?   data.manage.userId === authenticatedUser.id
                                :   1 === 2 // used to exit check
                            :   1 === 2 // used to exit check
                        )

                        // or were sent to my supportDesk
                        || ( 
                            // get the supportDeskId my userId is logged in with and compare with ticket supportDeskId
                            data.manage != null 
                            ?   data.manage.supportDeskId != null
                                ?   ( 
                                        data.manage.supportDeskId === sessions
                                            .find( session => 
                                                session.userId === authenticatedUser.id 
                                            ).supportDeskId 
                                    )
                                :   1 === 2 // used to exit check
                            :   1 === 2 // used to exit check
                        )
                    )
                )
                    
            )
        )

        // check users that are online
        const onlineSessions = sessions.filter( session => Number(session.status) === 1 )


        return (
            <div className="home-left-content3-bottom quickStats-container" style={{paddingBottom:15}}>
            {/* <div className="quickStats-container" style={{paddingBottom:15}}> */}
                <div className="quickStats-group">
                    <MyCustomersCount ticketsCount={ priorityTickets.length } />
                    <AllCustomersCount ticketsCount={ tickets.filter(ticket => !ticket.status ).length } />
                    <TotalAgentsOnline onlineAgentsCount={ onlineSessions.length } />
                    <TotalAgentsActive activeAgentsCount={ tickets.filter( data => data.status === 1 ).length } />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { tickets, auth, sessions } = state
    return {
        tickets: tickets.tickets,
        sessions: sessions.sessions,
        activeTicketId: tickets.activeTicketId,
        authenticatedUser: auth.authenticatedUser
    }
  }
  
  export default connect(mapStateToProps, {})(CurrentlyBeingServed);
  


